module.exports = __webpack_public_path__ + "media/images/web/favicon/android-icon-72x72-f884b7ea3b6c241e05092b0c0102bca8.png";